import { MOBILE_MEDIA_QUERY } from "@/lib/breakpoints";
import { useMediaQuery } from "./useMediaQuery";

/**
 * True on phones + tablets (viewport below the desktop `lg` breakpoint, 1024px).
 * Drives touch-only behaviour: disabling grid drag and swapping dialogs for drawers.
 */
export const useIsMobile = (): boolean => useMediaQuery(MOBILE_MEDIA_QUERY);
